import { SimpleLayout, ST } from '../components/SimpleLayout';

const wrap: React.CSSProperties = {
  maxWidth: 820,
  margin: '0 auto',
  padding: '110px 24px 24px',
};

const h2: React.CSSProperties = {
  fontSize: 24,
  fontWeight: 700,
  letterSpacing: -0.5,
  color: ST.text,
  margin: '40px 0 12px 0',
};

const h3: React.CSSProperties = {
  fontSize: 17,
  fontWeight: 700,
  color: ST.text,
  margin: '24px 0 8px 0',
};

const p: React.CSSProperties = {
  fontSize: 15,
  lineHeight: 1.7,
  color: ST.text,
  margin: '0 0 12px 0',
};

const muted: React.CSSProperties = {
  fontSize: 14,
  color: ST.textMuted,
  lineHeight: 1.6,
};

const ul: React.CSSProperties = {
  margin: '0 0 16px 0',
  paddingLeft: 22,
  fontSize: 15,
  lineHeight: 1.7,
  color: ST.text,
};

const divider: React.CSSProperties = {
  height: 1,
  background: ST.border,
  border: 0,
  margin: '32px 0',
};

const quote: React.CSSProperties = {
  background: ST.primarySoft,
  borderLeft: `4px solid ${ST.primary}`,
  padding: '12px 16px',
  borderRadius: '0 10px 10px 0',
  fontSize: 14,
  color: ST.text,
  margin: '0 0 16px 0',
};

const tableWrap: React.CSSProperties = {
  overflowX: 'auto',
  margin: '0 0 20px 0',
};

const table: React.CSSProperties = {
  width: '100%',
  borderCollapse: 'collapse',
  fontSize: 14,
  background: ST.surface,
  border: `1px solid ${ST.border}`,
  borderRadius: 12,
  overflow: 'hidden',
};

const th: React.CSSProperties = {
  textAlign: 'left',
  padding: '10px 14px',
  background: ST.surfaceAlt,
  fontWeight: 700,
  color: ST.text,
  borderBottom: `1px solid ${ST.border}`,
};

const td: React.CSSProperties = {
  padding: '10px 14px',
  borderBottom: `1px solid ${ST.border}`,
  color: ST.text,
};

const linkStyle: React.CSSProperties = {
  color: ST.primary,
  textDecoration: 'none',
  fontWeight: 500,
};

export function PrivacyPolicyPage() {
  return (
    <SimpleLayout>
      <article style={wrap}>
        <header
          style={{
            background: ST.surface,
            border: `1px solid ${ST.border}`,
            borderRadius: 16,
            padding: 28,
            marginBottom: 8,
          }}
        >
          <h1 style={{ fontSize: 34, fontWeight: 800, letterSpacing: -1.2, margin: 0, color: ST.text }}>
            Polityka Prywatności — Marmo Car
          </h1>
          <div style={{ marginTop: 16, fontSize: 14, color: ST.textMuted, lineHeight: 1.8 }}>
            <div>
              <b style={{ color: ST.text }}>Wersja:</b> 1.1
            </div>
            <div>
              <b style={{ color: ST.text }}>Data obowiązywania:</b> [DATA]
            </div>
            <div>
              <b style={{ color: ST.text }}>Administrator danych:</b> Marcin Czembrowski,{' '}
              <a href="mailto:support@marmocar.pl" style={linkStyle}>
                support@marmocar.pl
              </a>
            </div>
          </div>
        </header>

        <h2 style={h2}>1. Informacje ogólne</h2>
        <p style={p}>
          Niniejsza Polityka Prywatności opisuje, w jaki sposób Marcin Czembrowski („my", „nas",
          „Administrator") zbiera, wykorzystuje i chroni dane osobowe użytkowników aplikacji
          mobilnej <b>Marmo Car</b> („Aplikacja").
        </p>
        <p style={p}>
          Korzystając z Aplikacji, akceptujesz zasady opisane w niniejszej Polityce. Jeśli się z
          nimi nie zgadzasz, prosimy o nieinstalowanie lub odinstalowanie Aplikacji.
        </p>

        <hr style={divider} />

        <h2 style={h2}>2. Administrator danych osobowych</h2>
        <p style={p}>Administratorem Twoich danych osobowych jest osoba fizyczna:</p>
        <p style={p}>
          <b>Marcin Czembrowski</b>
          <br />
          E-mail:{' '}
          <a href="mailto:support@marmocar.pl" style={linkStyle}>
            support@marmocar.pl
          </a>
        </p>
        <p style={p}>
          Administrator nie wyznaczył Inspektora Ochrony Danych. Wszelkie sprawy dotyczące danych
          osobowych prosimy kierować bezpośrednio na powyższy adres e-mail.
        </p>

        <hr style={divider} />

        <h2 style={h2}>3. Jakie dane zbieramy i skąd</h2>
        <p style={p}>
          Podczas rejestracji i korzystania z Aplikacji przetwarzamy dane osobowe pobierane z konta
          Google użytkownika za pośrednictwem <b>logowania przez Google (Google Sign-In)</b>. Dane
          te są kopiowane do naszej bazy danych (Firebase Firestore) i mogą być przez nas
          modyfikowane wyłącznie w zakresie niezbędnym do świadczenia usługi — zmiany dokonane w
          Aplikacji nie są synchronizowane z powrotem do konta Google użytkownika.
        </p>
        <div style={tableWrap}>
          <table style={table}>
            <thead>
              <tr>
                <th style={th}>Dane</th>
                <th style={th}>Źródło</th>
                <th style={th}>Cel</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style={td}>Imię i nazwisko</td>
                <td style={td}>Konto Google użytkownika</td>
                <td style={td}>Personalizacja konta w Aplikacji</td>
              </tr>
              <tr>
                <td style={td}>Adres e-mail</td>
                <td style={td}>Konto Google użytkownika</td>
                <td style={td}>Identyfikacja użytkownika, komunikacja</td>
              </tr>
              <tr>
                <td style={td}>Identyfikator konta Google (Google UID)</td>
                <td style={td}>Google OAuth</td>
                <td style={td}>Uwierzytelnianie i powiązanie konta w bazie danych</td>
              </tr>
            </tbody>
          </table>
        </div>
        <blockquote style={quote}>
          Nie zbieramy haseł. Uwierzytelnianie odbywa się wyłącznie poprzez mechanizmy Google
          Sign-In — nie mamy dostępu do Twojego hasła Google.
        </blockquote>

        <hr style={divider} />

        <h2 style={h2}>4. Cel i podstawa prawna przetwarzania danych</h2>
        <p style={p}>Twoje dane przetwarzamy w następujących celach:</p>

        <h3 style={h3}>4.1 Wykonanie umowy / świadczenie usługi (art. 6 ust. 1 lit. b RODO)</h3>
        <ul style={ul}>
          <li>Umożliwienie rejestracji i logowania do Aplikacji.</li>
          <li>Tworzenie i zarządzanie kontem użytkownika.</li>
          <li>Personalizacja treści i funkcji Aplikacji.</li>
        </ul>

        <h3 style={h3}>4.2 Prawnie uzasadniony interes administratora (art. 6 ust. 1 lit. f RODO)</h3>
        <ul style={ul}>
          <li>Zapewnienie bezpieczeństwa Aplikacji i ochrona przed nadużyciami.</li>
          <li>Analiza techniczna i rozwiązywanie błędów.</li>
          <li>Analiza użytkowania Aplikacji w celu jej ulepszania (Google Analytics for Firebase).</li>
        </ul>

        <h3 style={h3}>4.3 Zgoda użytkownika (art. 6 ust. 1 lit. a RODO)</h3>
        <p style={p}>
          Zgoda na przetwarzanie danych jest wyrażana aktywnie przez użytkownika w trakcie
          rejestracji poprzez zaakceptowanie niniejszej Polityki Prywatności. Użytkownik może
          cofnąć zgodę w dowolnym momencie, kontaktując się z administratorem lub usuwając konto —
          bez wpływu na zgodność z prawem przetwarzania dokonanego przed cofnięciem zgody.
        </p>

        <hr style={divider} />

        <h2 style={h2}>5. Przechowywanie danych — Firebase</h2>
        <p style={p}>
          Dane użytkowników są przechowywane w usłudze <b>Firebase Authentication</b> oraz{' '}
          <b>Firebase Firestore / Realtime Database</b> dostarczanej przez <b>Google LLC</b>{' '}
          (Firebase to platforma Google).
        </p>
        <ul style={ul}>
          <li>
            Serwery Firebase mogą znajdować się na terenie Europejskiego Obszaru Gospodarczego lub
            poza nim (m.in. w USA). Google LLC przystąpił do mechanizmu Data Privacy Framework i
            zapewnia odpowiedni poziom ochrony danych.
          </li>
          <li>
            Polityka prywatności Google/Firebase:{' '}
            <a
              href="https://firebase.google.com/support/privacy"
              target="_blank"
              rel="noopener noreferrer"
              style={linkStyle}
            >
              https://firebase.google.com/support/privacy
            </a>
          </li>
        </ul>

        <hr style={divider} />

        <h2 style={h2}>6. Odbiorcy danych</h2>
        <p style={p}>Twoje dane mogą być udostępniane:</p>
        <ul style={ul}>
          <li>
            <b>Google LLC</b> — w zakresie niezbędnym do świadczenia usług Firebase, Google Sign-In
            oraz Google Analytics for Firebase.
          </li>
          <li>
            <b>Podmiotom świadczącym usługi techniczne</b> — wyłącznie na podstawie umów
            powierzenia przetwarzania danych.
          </li>
          <li>
            <b>Organom publicznym</b> — wyłącznie gdy wymagają tego przepisy prawa.
          </li>
        </ul>
        <p style={p}>Nie sprzedajemy Twoich danych osobowych żadnym podmiotom trzecim.</p>

        <hr style={divider} />

        <h2 style={h2}>7. Okres przechowywania danych</h2>
        <p style={p}>
          Twoje dane osobowe przechowujemy przez czas trwania aktywnej subskrypcji w Aplikacji. Po
          jej wygaśnięciu dane są przechowywane przez dodatkowe <b>30 dni</b>, po czym są trwale
          usuwane z naszych systemów. Okres ten umożliwia ewentualne wznowienie subskrypcji bez
          utraty danych.
        </p>
        <p style={p}>
          W przypadku złożenia przez użytkownika żądania usunięcia danych (prawo do bycia
          zapomnianym) dane są usuwane <b>niezwłocznie</b>, bez oczekiwania na upływ powyższego
          okresu.
        </p>
        <p style={p}>
          Po usunięciu danych osobowych możemy przechowywać wyłącznie{' '}
          <b>zanonimizowane dane statystyczne</b>, które nie są w żaden sposób powiązane z
          konkretną osobą i nie stanowią danych osobowych w rozumieniu RODO.
        </p>

        <hr style={divider} />

        <h2 style={h2}>8. Twoje prawa</h2>
        <p style={p}>Na podstawie RODO przysługują Ci następujące prawa:</p>
        <ul style={ul}>
          <li>
            <b>Prawo dostępu</b> — możesz zażądać informacji o tym, jakie dane przetwarzamy.
          </li>
          <li>
            <b>Prawo do sprostowania</b> — możesz poprosić o poprawienie nieprawidłowych danych.
          </li>
          <li>
            <b>Prawo do usunięcia</b> („prawo do bycia zapomnianym") — możesz zażądać usunięcia
            swoich danych, o ile nie stoją temu na przeszkodzie inne przepisy.
          </li>
          <li>
            <b>Prawo do ograniczenia przetwarzania</b> — możesz zażądać wstrzymania przetwarzania
            danych w określonych sytuacjach.
          </li>
          <li>
            <b>Prawo do przenoszenia danych</b> — możesz otrzymać swoje dane w ustrukturyzowanym
            formacie.
          </li>
          <li>
            <b>Prawo sprzeciwu</b> — możesz wnieść sprzeciw wobec przetwarzania danych na podstawie
            prawnie uzasadnionego interesu.
          </li>
          <li>
            <b>Prawo do skargi</b> — jeżeli uważasz, że przetwarzanie narusza przepisy, możesz
            złożyć skargę do właściwego organu nadzorczego (w Polsce:{' '}
            <b>Prezes Urzędu Ochrony Danych Osobowych</b>, ul. Stawki 2, 00-193 Warszawa,{' '}
            <a
              href="https://www.uodo.gov.pl"
              target="_blank"
              rel="noopener noreferrer"
              style={linkStyle}
            >
              www.uodo.gov.pl
            </a>
            ).
          </li>
        </ul>
        <p style={p}>
          Aby skorzystać z przysługujących Ci praw, skontaktuj się z nami:{' '}
          <a href="mailto:support@marmocar.pl" style={linkStyle}>
            <b>support@marmocar.pl</b>
          </a>
        </p>

        <hr style={divider} />

        <h2 style={h2}>9. Bezpieczeństwo danych</h2>
        <p style={p}>
          Stosujemy odpowiednie środki techniczne i organizacyjne w celu ochrony Twoich danych
          przed nieuprawnionym dostępem, utratą lub zniszczeniem, w tym:
        </p>
        <ul style={ul}>
          <li>szyfrowanie transmisji danych (HTTPS/TLS),</li>
          <li>mechanizmy uwierzytelniania Google Sign-In (OAuth 2.0),</li>
          <li>reguły bezpieczeństwa Firebase (Firebase Security Rules).</li>
        </ul>

        <hr style={divider} />

        <h2 style={h2}>10. Analityka — Google Analytics for Firebase</h2>
        <p style={p}>
          Aplikacja korzysta z usługi <b>Google Analytics for Firebase</b> dostarczanej przez Google
          LLC w celu analizy sposobu korzystania z Aplikacji i jej ulepszania.
        </p>
        <p style={p}>Google Analytics for Firebase może zbierać i przetwarzać następujące dane:</p>
        <ul style={ul}>
          <li>zdarzenia w Aplikacji (np. ekrany, kliknięcia),</li>
          <li>czas i częstotliwość sesji,</li>
          <li>typ i model urządzenia, wersja systemu operacyjnego,</li>
          <li>anonimizowany adres IP,</li>
          <li>identyfikatory instalacji aplikacji.</li>
        </ul>
        <p style={p}>
          Dane zbierane przez Google Analytics są przetwarzane zgodnie z polityką prywatności
          Google:{' '}
          <a
            href="https://policies.google.com/privacy"
            target="_blank"
            rel="noopener noreferrer"
            style={linkStyle}
          >
            https://policies.google.com/privacy
          </a>
          .
        </p>
        <p style={p}>
          Możesz ograniczyć zbieranie danych analitycznych poprzez ustawienia prywatności swojego
          urządzenia mobilnego (iOS: Ustawienia &gt; Prywatność &gt; Śledzenie; Android: Ustawienia
          &gt; Google &gt; Reklamy).
        </p>

        <hr style={divider} />

        <h2 style={h2}>11. Aplikacje i usługi podmiotów trzecich</h2>
        <p style={p}>
          Aplikacja korzysta z usług firm trzecich, które mają własne polityki prywatności:
        </p>
        <ul style={ul}>
          <li>
            <b>Google Sign-In / Google Identity</b> —{' '}
            <a
              href="https://policies.google.com/privacy"
              target="_blank"
              rel="noopener noreferrer"
              style={linkStyle}
            >
              https://policies.google.com/privacy
            </a>
          </li>
          <li>
            <b>Firebase (Google LLC)</b> —{' '}
            <a
              href="https://firebase.google.com/support/privacy"
              target="_blank"
              rel="noopener noreferrer"
              style={linkStyle}
            >
              https://firebase.google.com/support/privacy
            </a>
          </li>
          <li>
            <b>Google Analytics for Firebase</b> —{' '}
            <a
              href="https://firebase.google.com/support/privacy"
              target="_blank"
              rel="noopener noreferrer"
              style={linkStyle}
            >
              https://firebase.google.com/support/privacy
            </a>
          </li>
        </ul>

        <hr style={divider} />

        <h2 style={h2}>12. Profilowanie i zautomatyzowane decyzje</h2>
        <p style={p}>
          Dane osobowe użytkowników nie są wykorzystywane do profilowania ani zautomatyzowanego
          podejmowania decyzji w rozumieniu art. 22 RODO.
        </p>

        <hr style={divider} />

        <h2 style={h2}>13. Niezbędność podania danych</h2>
        <p style={p}>
          Podanie danych osobowych (imię i nazwisko, adres e-mail, Google UID) jest dobrowolne,
          jednak niezbędne do korzystania z Aplikacji — brak tych danych uniemożliwia rejestrację i
          logowanie.
        </p>

        <hr style={divider} />

        <h2 style={h2}>14. Dzieci</h2>
        <p style={p}>
          Aplikacja nie jest przeznaczona dla osób poniżej 16. roku życia. Nie zbieramy świadomie
          danych osobowych od dzieci. Jeśli jako rodzic lub opiekun prawny zauważysz, że Twoje
          dziecko przekazało nam dane, skontaktuj się z nami — niezwłocznie je usuniemy.
        </p>

        <hr style={divider} />

        <h2 style={h2}>15. Zmiany w Polityce Prywatności</h2>
        <p style={p}>
          Możemy aktualizować niniejszą Politykę. O istotnych zmianach poinformujemy Cię za
          pośrednictwem powiadomienia w Aplikacji lub e-mailem. Data „Wersja" na górze dokumentu
          zawsze wskazuje aktualną datę obowiązywania.
        </p>

        <hr style={divider} />

        <h2 style={h2}>16. Kontakt</h2>
        <p style={p}>
          W przypadku pytań dotyczących niniejszej Polityki Prywatności lub przetwarzania Twoich
          danych prosimy o kontakt:
        </p>
        <p style={p}>
          <b>Marcin Czembrowski</b>
          <br />
          E-mail:{' '}
          <a href="mailto:support@marmocar.pl" style={linkStyle}>
            <b>support@marmocar.pl</b>
          </a>
        </p>

        <hr style={divider} />

        <p style={{ ...muted, fontStyle: 'italic', marginTop: 24 }}>
          Niniejsza Polityka Prywatności została sporządzona zgodnie z Rozporządzeniem Parlamentu
          Europejskiego i Rady (UE) 2016/679 z dnia 27 kwietnia 2016 r. (RODO).
        </p>
      </article>
    </SimpleLayout>
  );
}
